// test743
(743 && 0);
